import { HostListener, ElementRef, OnChanges } from '@angular/core';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { DropdownOption } from '../../../../globals/store/programs.data';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownComponent } from '../misc/dropdown.component';

@Component({
    selector: 'joi-input',
    imports: [CommonModule, FormsModule, DropdownComponent],
    template: `
<div class="input_wrap" [ngClass]="{oneLine: type === 'input', is_focused:is_focused}">
    <div class="wrap" [ngClass]="{is_iOS: is_iOS}">
        <input #input
          name="joi-input"
          [tabindex]="tabindex"
          [ngClass]="{hidden:type === 'textarea',focus_on_new:focusOnNew && type !== 'textarea', italicPlaceholder: italicPlaceholder, outlined: outlined}"
          (keydown.enter)="blur($event)"
          (keydown.tab)="emitTab($event)"
          [disabled]="disabled"
          [placeholder]="placeholder"
          (focusout)="unfocusInput.emit()"
          (focus)="focused.emit()"
          (input)="checkForAllowableCharacters()"
          [(ngModel)]="model"
          [type]="inputType"
          [max]="maxValue ? maxValue : null"
          [min]="minValue ? minValue : null"
          [maxlength]="maxlength"
          [pattern]="pattern" />
        <textarea #textarea
          rows="1"
          name="joi-textarea"
          [tabindex]="tabindex"
          [ngClass]="{hidden:type !== 'textarea',focus_on_new:focusOnNew && type === 'textarea', italicPlaceholder: italicPlaceholder, outlined: outlined}"
          (keydown.enter)="blur($event)"
          (keydown.tab)="emitTab($event)"
          (focusout)="unfocusInput.emit()"
          [disabled]="disabled"
          [placeholder]="placeholder"
          [(ngModel)]="model"
          [maxlength]="maxlength"
          [pattern]="pattern"
        ></textarea>
        <dropdown *ngIf="!!dropdownOptions" [selections]="dropdownOptions" (select)="chooseDropdown.emit($event)"></dropdown>
          
    </div>
    <div class="input_sizebox" [ngClass]="{oneLine: type === 'input', ends_in_return:this.ends_in_return}" [textContent]="displayValue || model || placeholder"></div>
</div>
<span #span 
  [ngClass]="{placeholder:!model, outlined: outlined, nowrap:type==='input', is_focused:is_focused, ends_in_return:this.ends_in_return, italicPlaceholder: italicPlaceholder && !model}"
  [textContent]="displayValue || model || placeholder"
  (click)="input.focus()"></span>
    `,
    styleUrls: ['joi-input.component.scss'],
    standalone: true,
})
export class JoiInputComponent implements OnInit, OnChanges {

    hightlight_timer
    is_not_auto_submit:boolean;
    has_changed = false;
    is_focused = false;
    is_iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    ends_in_return = false;
    @Input() dropdownOptions: DropdownOption[]
    @Output() chooseDropdown: EventEmitter<DropdownOption> = new EventEmitter()
    @Input() disabled: boolean;
    @Input() placeholder: string;
    @Input() model: any;
    @Input() autoSelect:boolean;
    @Input() name:string;
    @Input() pattern:RegExp;
    @Input() maxlength:number;
    @Input() focusOnNew:boolean;
    @Input() fixedWidth:boolean;
    @Input() tabindex:number;
    @Input() italicPlaceholder: boolean = false
    @Input() returnable = false;
    @Input() disableAutoSubmit:boolean;
    @Input() stretch_minimum:number; // possibly not needed
    @Input() allowableCharacters:string
    @Output() modelChange: EventEmitter<any> = new EventEmitter();
    @Output() joiChange: EventEmitter<any> = new EventEmitter();
    @Output() unfocusInput: EventEmitter<any> = new EventEmitter();
    @Output() focused: EventEmitter<any> = new EventEmitter();
    @Input() each:any;
    @Output() eachChange: EventEmitter<string> = new EventEmitter();
    @Output() onTab: EventEmitter<any> = new EventEmitter();
    @Input() type: 'input' | 'textarea' = 'input';
    @Input() inputType = 'text'
    @Input() maxValue = null
    @Input() minValue = null
    @Input() displayValue = null
    @Input() outlined = false

    @ViewChild('input', { static: true }) input;
    @ViewChild('textarea', { static: true }) textarea;
    @ViewChild('span', { static: true }) span;

    @HostListener('mouseover') onHover(){
      this.resize(this.input.nativeElement)
    }

    @HostListener('click') onClick() {
      this.resize(this.input.nativeElement)
    }
    @HostListener('input') onInput() {
      if(this.each) this.eachChange.emit(this.input.nativeElement.value)
      this.resize(this.input.nativeElement)
      this.has_changed = true;
    }
    @HostListener('change') onChange() {
      this.resize(this.input.nativeElement)
      this.has_changed = true;
    }
    // @HostListener('mouseout') onHoverOff(){
      // this.span.nativeElement.style.display = 'inline';
    // }

    constructor(public el:ElementRef) {}

    setModel(model) {
      // sometimes the model won't update as the input updates, so need an explicit way to change the model
      this.model = model
    }

    manualFocus() {
      // the auto focus functionality does not work for this within manage wrapper
      this.input.nativeElement.focus()
      // if (this.type === 'input') this.input
 
    }

    checkForAllowableCharacters() {
      if (!this.allowableCharacters) return
      let value = this.input.nativeElement.value
      if (value) value = value.split("").filter(c => this.allowableCharacters.includes(c)).join("")
      this.input.nativeElement.value = value

    }

    ngOnChanges(changes) {
      // feel free to get rid of this if you can get rid of the hover effect on joi input when the input is otherwise disabled in another way
      const d = changes.disabled
      if (d && d.currentValue !== d.previousValue) {
        if (d.currentValue) this.el.nativeElement.classList.add("disabled")
        else this.el.nativeElement.classList.remove("disabled")
      }
    }

    ngOnInit() {
      if(this.fixedWidth) {
        this.el.nativeElement.classList.add("width_set");
      }

      if(this.type === 'textarea') this.input = this.textarea;
      if(this.input){
        this.input.nativeElement.onfocus = (evt) => {
          if(this.autoSelect){
            this.highlightMe(evt);
          }
          this.is_focused = true;
        }
        this.input.nativeElement.onblur = (evt) => {
          if(this.disableAutoSubmit && !this.is_not_auto_submit) {
            this.is_not_auto_submit = false;
            return;
          }
          this.is_not_auto_submit = false;
          this.input.nativeElement.value = this.input.nativeElement.value.replace(/[ \t]+\s$/, '');
          if(!this.returnable){
            this.input.nativeElement.value = this.input.nativeElement.value.replace(/\s+/g, ' ')
          }
          // this.input.nativeElement.value = this.input.nativeElement.value.trimEnd();
          this.is_focused = false;
          if(!this.has_changed) return;
          this.modelChange.emit(this.input.nativeElement.value);
          this.joiChange.emit(this.input.nativeElement.value);
        }
        setTimeout(_=>{
            this.resize(this.input.nativeElement);
        }, 0);
      }
    }



    highlightMe(evt){
      this.hightlight_timer = setTimeout(_=>{
        evt.target.select();
        clearTimeout(this.hightlight_timer)
      },0);
    }

    blur(evt){
      console.log("Blur called")
      if(this.returnable){
        setTimeout(_=>{
          this.resize(this.input.nativeElement)
        },0)
        return;
      }
      this.is_not_auto_submit = true;
      this.input.nativeElement.blur(evt);
      evt.stopPropagation();
    }

    emitTab(evt){
      if(this.onTab) {
        // console.log('evt ', evt);
        this.onTab.emit(evt)
      }
    }

    resize(element) {
      // console.log("Resize called")

      if (this.disabled) return
      const cs = getComputedStyle(element);
      let offset = 0;
      let empty;

      if (!element.value && element.placeholder) {
          empty = true;
          element.value = element.placeholder;
      }
      const type = element.nodeName.toLowerCase();
      const span = this.span.nativeElement;

      if (type === "textarea") {
          element.style.height = "0";

          if (cs.boxSizing === "border-box") {
              offset = element.offsetHeight;
          }else if (cs.boxSizing === "content-box") {
              offset = -element.clientHeight + parseFloat(cs.minHeight);
          }
          const height = span.clientHeight;
          const text_value = this.input.nativeElement.value;
          this.ends_in_return = text_value.endsWith("\n");
          const extra = this.ends_in_return ? 20 : 0;
          element.style.height = height + offset + extra + "px";
      }else if(type === "input" && !this.fixedWidth) {
          // First test that it is actually visible, otherwise all measurements are off
          element.style.width = "1000px";
          if (element.offsetWidth) {
              element.style.width = this.stretch_minimum || "0";

              if (cs.boxSizing === "border-box") {
                  offset = element.offsetWidth;
              }else if (cs.boxSizing === "padding-box") {
                  offset = element.clientWidth;
              }else if (cs.boxSizing === "content-box") {
                  offset = parseFloat(cs.minWidth);
              }
              let calc = element.scrollWidth - element.clientWidth;
              if(calc === 0) calc = span.clientWidth + 1;
              let width = Math.max(offset, calc);
              element.style.width = width + "px";

              // To bulletproof, we will set scrollLeft to a
              // huge number, and read that back to see what it was clipped to
              // and increment width by that much, iteratively

              for (let i=0; i<10; i++) { // max iterations
                  element.scrollLeft = 1e+10;

                  if (element.scrollLeft === 0) {
                      break;
                  }

                  width += element.scrollLeft;

                  element.style.width = width + "px";
              }
          }else {
              // Element is invisible, just set to something reasonable
              element.style.width = element.value.length + 1 + "ch";
          }
      }else if (type === "select") {
          const selectedIndex = element.selectedIndex > 0? element.selectedIndex : 0;

          // Need to use dummy element to measure :(
          let option = document.createElement("_");
          option.textContent = element.options[selectedIndex].textContent;
          element.parentNode.insertBefore(option, element.nextSibling);

          // The name of the appearance property, as it might be prefixed
          let appearance;

          for (const property in cs) {
              if(!cs.hasOwnProperty(property)) continue;
              const value = cs[property];
              if (!/^(width|webkitLogicalWidth|length)$/.test(property) && typeof value === "string") {
                  // console.log(property, option.offsetWidth, cs[property]);
                  option.style[property] = value;

                  if (/appearance$/i.test(property)) {
                      appearance = property;
                  }
              }
          }

          option.style.width = "";

          if (option.offsetWidth > 0) {
              element.style.width = option.offsetWidth + "px";

              if (!cs[appearance] || cs[appearance] !== "none") {
                  // Account for arrow
                  element.style.width = "calc(" + element.style.width + " + 2em)";
              }
          }

          option.parentNode.removeChild(option);
          option = null;
      }
      const text = this.input.nativeElement.value || this.input.nativeElement.placeholder

      if (empty || element.value === "") {
          element.value = "";
          return
      }
    }
}
